import { Box, Typography } from '@mui/material';

import { ScoreCo2Label } from '@/ui/pages/app/components/quiz-panel/co2/components/ScoreCo2Label';
import { ColorsRaw } from '@/ui/theme/colors-raw';

export function BoxData({
  title,
  lines,
  footer,
  score,
  valueColor,
}: {
  title: string;
  lines: string[];
  footer?: string;
  score?: number;
  valueColor?: string;
}) {
  return (
    <Box
      sx={{
        border: `1px solid ${ColorsRaw.anthracite.Anthracite_3}`,
        borderRadius: '12px',
        p: 2,
        mt: 2,
        backgroundColor: ColorsRaw.anthracite.Anthracite_2,
      }}
    >
      <Box
        display={'flex'}
        justifyContent={'space-between'}
        alignItems={'center'}
        marginBottom={1}
      >
        <Typography sx={{ color: ColorsRaw.main.Navy_Light, fontSize: 16 }}>
          {title}
        </Typography>
      </Box>
      {score !== undefined && (
        <Box display="flex" justifyContent="flex-end" mb={2}>
          <ScoreCo2Label score={score} scoreColor={valueColor} />
        </Box>
      )}
      {lines.map((line) => (
        <BoxDataLine key={line} value={line} valueColor={valueColor} />
      ))}
      {footer && (
        <Box sx={{ mt: 1 }}>
          <Typography color={ColorsRaw.secondary.Light_Grey}>
            {footer}
          </Typography>
        </Box>
      )}
    </Box>
  );
}

function BoxDataLine({
  value,
  valueColor,
}: {
  value: string;
  valueColor?: string;
}) {
  const match = value.match(/^(\d+)(.*)$/);
  const digits = match ? match[1] : '';
  const unit = match ? match[2] : value;
  return (
    <Typography sx={{ fontSize: 20, fontWeight: 'bold' }}>
      <Typography
        component="span"
        sx={{ color: valueColor, fontSize: '1.25rem', fontWeight: '900' }}
      >
        {digits}
      </Typography>
      {unit}
    </Typography>
  );
}
